/**
 * Returns an object containing functions to trap and un-trap focus on an element.
 * @param el Element to trap focus on.
 * @returns Object containing trap and un-trap functions.
 */
export const createTrapper = (el) => {
    const trappedEls = new Set();
    const traverse = (...els) => {
        for (const currentEl of els) {
            if (currentEl === el) {
                return;
            }
            if (currentEl instanceof HTMLElement && !currentEl.contains(el) && !currentEl.inert) {
                currentEl.inert = true;
                trappedEls.add(currentEl);
                continue;
            }
            traverse(...currentEl.children);
        }
    };
    const trap = () => {
        traverse(document.body);
    };
    const untrap = () => {
        for (const el of trappedEls) {
            el.inert = false;
        }
        trappedEls.clear();
    };
    return {
        trap,
        untrap,
    };
};
